import { directBookingSchema, type LandingContent, type LandingFieldGroup, type LandingVariantText } from "./schema";
import { resolveContent } from "./resolve";
import { webDevelopmentSanDiegoDefaults, webDevelopmentSanDiegoShowcase } from "./pages/webDevelopmentSanDiego";
import type { BuiltInShowcase } from "./showcase";

export interface LandingPageDefinition {
  slug: string;
  path: string;
  name: string;
  leadSource: string;
  contentKey: string;
  defaults: LandingContent;
  schema: LandingFieldGroup[];
  /** Websites shown in "Recent work" until an admin picks others. */
  showcase: BuiltInShowcase;
}

/** Every marketing landing page. The admin section lists these automatically. */
export const LANDING_PAGES = [
  {
    slug: "web-development-san-diego",
    path: "/web-development-san-diego",
    name: "Web Development, San Diego",
    leadSource: "lp-web-development-san-diego",
    contentKey: "landing.web-development-san-diego",
    defaults: webDevelopmentSanDiegoDefaults,
    schema: directBookingSchema,
    showcase: webDevelopmentSanDiegoShowcase,
  },
] as const satisfies readonly LandingPageDefinition[];

export const webDevelopmentSanDiego: LandingPageDefinition = LANDING_PAGES[0];

export function normalizeLandingPath(pathname: string) {
  return pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
}
export function getLandingPageByPath(pathname: string): LandingPageDefinition | undefined {
  const normalized = normalizeLandingPath(pathname);
  return LANDING_PAGES.find((page) => page.path === normalized);
}
export function getLandingPageBySlug(slug: string): LandingPageDefinition | undefined {
  return LANDING_PAGES.find((page) => page.slug === slug);
}

export function resolveLandingContent(definition: LandingPageDefinition, raw: unknown): LandingContent {
  return resolveContent(definition.schema, definition.defaults, raw);
}

export function pickVariant(content: LandingContent, key: string | null): { key: string; text: LandingVariantText } {
  const chosen = key && Object.prototype.hasOwnProperty.call(content.variants, key) ? key : "default";
  return { key: chosen, text: content.variants[chosen] };
}
